var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsuarioIcono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.89 122.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a3afe615-81ce-4c25-b46d-65757ea9d33f{fill:#868686;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "usuario") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ae65b84f-192f-4c8b-aeed-2a1bf193f518",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a2311dcc-8a20-4d14-ba49-65f8b0887382",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a3afe615-81ce-4c25-b46d-65757ea9d33f",
    d: "M68,55.26A34,34,0,0,1,40.44,69a34,34,0,0,1-27-13A38.58,38.58,0,0,0,0,85.11v37.43H80.89V83A36.52,36.52,0,0,0,68,55.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a3afe615-81ce-4c25-b46d-65757ea9d33f",
    cx: 40.44,
    cy: 31.84,
    r: 31.84
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarioIcono);
export default __webpack_public_path__ + "static/media/usuario_icono.5d7bf969.svg";
export { ForwardRef as ReactComponent };